export default __webpack_public_path__ + "static/media/Forum.6b733c03.svg";